export const colors = {
  alto: '#E0E0E0',
  backgroundColor: '#F5F5F6',
  black: '#000',
  blackSqueeze: '#F0F4FA',
  borderColor: '#E4E4E4',
  borderTransparentGray: 'rgba(0, 0, 0, 0.12)',
  boulder: '#757575',
  bunker: '#0E1118',
  codGray: '#1C1C1C',
  dodgerBlue: '#2979FF',
  error: '#E96A6A',
  errorField: '#D53C2D',
  footerBackground: '#1C2429',
  gallery: '#EFEFEF',
  gold: '#FFD600',
  grayBackground: '#EAEDEE',
  hawkesBlue: '#DCE6FC',
  headerBackground: '#568AF4',
  hotCinnamon: '#E56125',
  mercury: '#E1E1E1',
  midnightBlue: '#00306B',
  osloGray: '#8D8F93',
  placeholder: '#A2A2A2',
  primary: '#426ABB',
  secondary: '#00A751',
  tableHeaderGray: '#40525D',
  warning: '#FF0000',
  white: '#FFF',
  wildSand: '#F5F5F5',
};

export const fieldTypes = {
  multipleChoiceField: 'multiple_choice_field',
  singleChoiceField: 'single_choice_field',
  textField: 'text_field',
};

export const prefixes = [
  'Ms.',
  'Mr.',
  'Mrs.',
  'Miss',
  'Mx.',
  'Dr.',
];
